import {Component, OnDestroy, OnInit} from '@angular/core';
import * as faceapi from '@vladmandic/face-api';
import {FaceApiService} from '../../../../services/face-api/face-api.service';

@Component({
  selector: 'app-face-expression-detection',
  templateUrl: './face-expression-detection.component.html',
  styleUrls: ['../../../../app.component.scss', '../faceapi.component.scss', './face-expression-detection.component.scss']
})
export class FaceExpressionDetectionComponent implements OnInit, OnDestroy {
  constructor(public faceApiService: FaceApiService) {
  }

  ngOnInit(): void {
    this.run();
  }

  ngOnDestroy(): void {
    this.faceApiService.stopStream();
  }

  async run() {
    const faceDetectorSelect = document.getElementById('selectFaceDetector') as HTMLSelectElement;
    const inputSizeSelect = document.getElementById('inputSize') as HTMLSelectElement;
    const videoEl = document.getElementById('inputVideo') as HTMLVideoElement;
    this.faceApiService.init(faceDetectorSelect, inputSizeSelect, videoEl);

    // load face detection and face expression recognition models
    await this.faceApiService.changeFaceDetector(this.faceApiService.TINY_FACE_DETECTOR);
    await faceapi.loadFaceExpressionModel('assets/faceapi/weights/');
    this.faceApiService.changeInputSize(224);

    // try to access users webcam and stream the images
    // to the video element
    videoEl.srcObject = await navigator.mediaDevices.getUserMedia({video: {}});
  }

  async onPlay() {
    await this.faceApiService.play(async () => {
      try {
        const options = this.faceApiService.getFaceDetectorOptions();
        const ts = Date.now();
        const result = await faceapi.detectSingleFace(this.faceApiService.videoEl, options).withFaceExpressions();
        this.faceApiService.updateTimeStats(Date.now() - ts);
        if (result) {
          const canvas = document.getElementById('overlay') as HTMLCanvasElement;
          const dims = faceapi.matchDimensions(canvas, this.faceApiService.videoEl, true);
          const resizedResult = faceapi.resizeResults(result, dims);
          const minConfidence = 0.05;
          if (!this.faceApiService.withoutBoxes) {
            faceapi.draw.drawDetections(canvas, resizedResult);
          }
          faceapi.draw.drawFaceExpressions(canvas, resizedResult, minConfidence);
        }
      } catch (e) {
        console.log(':(');
      }
    });
  }

}
